
import sdLink from '@smartdesign/vue/components/link';

export default {
  name: 'TableOfContents',
  components: {
    sdLink,
  },
};
